/*eslint-disable*/
import React, { Component } from 'react';
//import "./profilePage.css";
import store from 'store';
import { Redirect } from 'react-router';
import { graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';
// core components
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import MobileStepper from "@material-ui/core/MobileStepper";

// @material-ui/core components
import {
	Grid,
	Button,
	FormControl,
	LinearProgress,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Icon,
	Typography,
	withStyles,
	TextField
} from '@material-ui/core';

import userProfileStyles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx';

import { companyLoginDetails } from 'queries/Profile/queries';
import {
	UpdateCompanyDetail,
	UpdateAstuteDetails
} from 'queries/Profile/mutations';

import FormInput from 'components/Wrappers/materialUIWrappers/components/FormInput';
import FormInputPassword from 'components/Wrappers/materialUIWrappers/components/FormInputPassword';
import { Field, reduxForm } from 'redux-form';
import { change } from 'redux-form';
import { Logout, GetUserToken, GetUserId } from 'helpers/UserHelper';
import { successWarning, showSnack } from 'reducers/NotificationReducer';
import _ from 'lodash';

const required = value => (value ? undefined : 'Required');
const form = 'CLD';

const isEmptyOrSpaces = str => {
	return str === undefined || str === null || str.match(/^ *$/) !== null;
};

class CompanyLoginDetails extends Component {
	constructor(props) {
		super(props);
	}

	state = {
		initialized: false,
		openDialogs: [],
		astuteDialog: false,
		showPasswordAstute: false,
		showConfrimPasswordAstute: false,
		showPinAstute: false,
		showConfirmPinAstute: false,
		checkValidation: false
	};

	handleOpenAstuteDialog = () => {
		store.dispatch(change('CLD', 'astuteDetails.password', ''));
		store.dispatch(change('CLD', 'astuteDetails.confirmpassword', ''));
		store.dispatch(change('CLD', 'astuteDetails.pin', ''));
		store.dispatch(change('CLD', 'astuteDetails.confirmpin', ''));

		this.setState({
			astuteDialog: true,
			showPasswordAstute: false,
			showConfrimPasswordAstute: false,
			showPinAstute: false,
			showConfirmPinAstute: false,
			checkValidation: false
		});
	};

	handleCloseAstuteDialog = () => {
		this.setState({ astuteDialog: false });
	};

	handleClickOpenDialog = (target, userTargetDetail) => {
		store.dispatch(
			change(
				'CLD',
				'companyDetails.' + target + '.username',
				userTargetDetail && userTargetDetail.username
					? userTargetDetail.username
					: ''
			)
		);

		if (target !== 9) {
			store.dispatch(
				change('CLD', 'companyDetails.' + target + '.password', '')
			);
			store.dispatch(
				change('CLD', 'companyDetails.' + target + '.confirmpassword', '')
			);
		}

		var openDialogs = this.state.openDialogs.slice();
		openDialogs.filter(x => x.id === target)[0].open = true;
		if (target !== 9) {
			openDialogs.filter(x => x.id === target)[0].showPassword = false;
			openDialogs.filter(x => x.id === target)[0].showConfrimPassword = false;
		}

		this.setState({ openDialogs: openDialogs, checkValidation: false });
	};

	handleCloseDialog = id => {
		var openDialogs = this.state.openDialogs.slice();
		openDialogs.filter(x => x.id === id)[0].open = false;
		this.setState({ openDialogs: openDialogs });
	};

	toggleShowPassword = id => {
		var openDialogs = this.state.openDialogs.slice();
		const showPassword = openDialogs.filter(x => x.id === id)[0].showPassword;
		openDialogs.filter(x => x.id === id)[0].showPassword = !showPassword;
		this.setState({ openDialogs: openDialogs });
	};

	toggleShowConfirmPassword = id => {
		var openDialogs = this.state.openDialogs.slice();
		const showPassword = openDialogs.filter(x => x.id === id)[0]
			.showConfrimPassword;
		openDialogs.filter(x => x.id === id)[0].showConfrimPassword = !showPassword;
		this.setState({ openDialogs: openDialogs });
	};

	toggleShowPasswordAstute = attr => {
		const showPassword = this.state[attr];
		this.setState({ [attr]: !showPassword });
	};

	initializeForm(EnabledTargets, CompanyLoginD, AstuteDetails) {
		var companyDetails = {};
		var AstuteDetails;

		EnabledTargets.map(target => {
			let usersCompDetail = CompanyLoginD.find(c => c.targetId === target.id);

			companyDetails[target.id] = {
				username: usersCompDetail ? usersCompDetail.username : null
			};
		});

		this.props.initialize({
			companyDetails: { ...companyDetails },
			astuteDetails: {
				username:
					AstuteDetails && AstuteDetails.username
						? AstuteDetails.username
						: null
			}
		});

		this.setState({ initialized: true });
	}

	updateTargetDetails = (target, refetch) => {
		var pw = _.get(
			store.getState().form.CLD,
			`values.companyDetails.${target.id}.password`,
			null
		);
		var cpw = _.get(
			store.getState().form.CLD,
			`values.companyDetails.${target.id}.confirmpassword`,
			null
		);
		var username = _.get(
			store.getState().form.CLD,
			`values.companyDetails.${target.id}.username`,
			null
		);

		if (
			isEmptyOrSpaces(username) ||
			(target.id != 1 && target.id != 9 && (isEmptyOrSpaces(pw) || isEmptyOrSpaces(cpw)))
		) {
			store.dispatch(
				showSnack({
					message: 'Please fill in all Details.',
					color: 'danger'
				})
			);
			this.setState({ checkValidation: true });
			return;
		}

		if (target.id != 1 && target.id != 9 && pw !== cpw) {
			store.dispatch(
				showSnack({
					message: 'Password do not match.',
					color: 'danger'
				})
			);
			return;
		}

		this.setState({ checkValidation: false });

		var input = {
			userId: GetUserId(),
			token: GetUserToken(),
			target: target.id.toString(),
			username: username,
			password: pw ? pw : ''
		};

		this.props
			.UpdateCompanyDetail({
				variables: {
					input
				}
			})
			.then(resp => {
				store.dispatch(
					successWarning({
						open: true,
						title: target.name + ' Details Updated!'
					})
				);

				this.handleCloseDialog(target.id);
				refetch();
			})
			.catch(error => {
				store.dispatch(
					showSnack({
						message: 'Unfortunately, an error has occured',
						color: 'danger'
					})
				);
			});
	};

	updateAstuteDetails = refetch => {
		var pw = _.get(
			store.getState().form.CLD,
			'values.astuteDetails.password',
			null
		);

		var pin = _.get(
			store.getState().form.CLD,
			'values.astuteDetails.pin',
			null
		);

		var cpw = _.get(
			store.getState().form.CLD,
			'values.astuteDetails.confirmpassword',
			null
		);

		var cpin = _.get(
			store.getState().form.CLD,
			'values.astuteDetails.confirmpin',
			null
		);

		var username = _.get(
			store.getState().form.CLD,
			'values.astuteDetails.username',
			null
		);

		

		if (
			!isEmptyOrSpaces(pw) &&
			!isEmptyOrSpaces(cpw) &&
			!isEmptyOrSpaces(username) &&
			!isEmptyOrSpaces(pin) &&
			!isEmptyOrSpaces(cpin)
		) {
			this.setState({ checkValidation: false });
			if (pw !== cpw) {
				store.dispatch(
					showSnack({
						message: 'Password do not match.',
						color: 'danger'
					})
				);
			} else if (pin !== cpin) {
				store.dispatch(
					showSnack({
						message: 'Pins do not match.',
						color: 'danger'
					})
				);
			} else {
				var input = {
					userId: GetUserId(),
					token: GetUserToken(),
					username: username,
					password: pw,
					pin: pin
				};

				this.props
					.UpdateAstuteDetails({
						variables: {
							input
						}
					})
					.then(resp => {
						store.dispatch(
							successWarning({
								open: true,
								title: 'Astute Details Updated!'
							})
						);

						this.handleCloseAstuteDialog();
						refetch();
					})
					.catch(error => {
						store.dispatch(
							showSnack({
								message: 'Unfortunately, an error has occured',
								color: 'danger'
							})
						);
					});
			}
		} else {
			store.dispatch(
				showSnack({
					message: 'Please fill in all Details.',
					color: 'danger'
				})
			);
			this.setState({ checkValidation: true });
		}
	};

	render() {
		var backRender = function()
		{
			if(localStorage.getItem('userType') == '')
				return ""
			else
			 return "none"
		}
		const validate = [];
		validate.push(required);

		if (this.props.data.loading) {
			return <LinearProgress />;
		}

		var { data } = this.props;
		if (
			data.error &&
			data.error.message &&
			data.error.message === 'GraphQL error: invalid token'
		) {
			Logout();
			return <Redirect to="/app/portal/login" />;
		}

		const refetch = data.refetch;

		let CompanyLoginD = data.CompanyLoginD;
		let EnabledTargets = data.EnabledTargets;
		let AstuteDetails = data.AstuteDetails;

		if (!this.state.initialized) {
			this.initializeForm(EnabledTargets, CompanyLoginD, AstuteDetails);
		}

		if (this.state.openDialogs.length !== EnabledTargets.length) {
			let openDialogs = [];

			EnabledTargets.map(t => {
				openDialogs.push({
					open: false,
					id: t.id,
					showPassword: false,
					showConfrimPassword: false
				});

				return t;
			});

			this.setState({ openDialogs: openDialogs });
		}

		return (
			<div>
				<Grid container>
					<GridItem xs={12} sm={12} md={10} style={{ margin: 'auto' }}>
					<div className={"stepperDiv"}>
                  <MobileStepper
                    type="progress"
                    steps={0}
					position="left"
					
					style={{ display : backRender() }}
					activeStep={this.state.page}
                    backButton={
                      <div style={{ display: "flex" }}>
                        {true ? (
                          <Button
						  variant="outlined"
						  className="outlinedButton"
						  color="secondary"
						  style={{ marginLeft: "10px" }}
						  onClick={() => this.props.history.goBack()}
						  disabled={this.state.page === 0 ? true : false}
						>
						  Back
                          </Button>
                        ) : (
                          <div />
                        )}

                      </div>
                    }
                    
                  />
                </div>
						<Card>
							<CardBody>
								<Grid direction="column" container>
									<GridItem
										xs={12}
										sm={12}
										md={12}
										style={{ margin: 'auto', marginBottom: '50px' }}
									>
										
										<Typography
											variant="headline"
											className="typography"
											style={{ textAlign: 'center' }}
										>
											FSP Login Detail
											<div
												style={{
													borderBottom: '1px solid #cccccc69',
													margin: '5px auto',
													width: '50%'
												}}
											/>
											<Typography variant="caption">
												This is your Broker login details at the specific FSP's
											</Typography>
										</Typography>
									</GridItem>
									{EnabledTargets.map(t => {
										if(t.id == 1)
										return;
										let dialog = this.state.openDialogs.find(
											x => x.id === t.id
										);
										let openD = dialog ? dialog.open : false;
										let userTargetDetail = CompanyLoginD.find(
											c => c.targetId === t.id
										);

										return (
											<GridItem xs={12} sm={12} md={12} key={t.id}>
												<Card
													className="targetCard"
													style={{ paddingTop: '5px' }}
												>
													<Grid container>
														<GridItem
															xs={12}
															sm={12}
															md={4}
															className="affiliationsGridItem"
														>
															<img
																src={
																	'/assets/logo/' +
																	t.name.toLowerCase() +
																	'.png'
																}
																className="targetAffiliationLogo"
																style={{ alignSelf: 'center' }}
															/>
														</GridItem>
														<GridItem
															xs={12}
															sm={6}
															md={4}
															className="affiliationsGridItem"
														>
															{userTargetDetail &&
															userTargetDetail.enabled &&
															userTargetDetail.username ? (
																<React.Fragment>
																	<Typography variant="caption">
																		Username:{' '}
																	</Typography>
																	<Typography variant="subheading">
																		{userTargetDetail.username}
																	</Typography>
																</React.Fragment>
															) : null}
														</GridItem>
														<GridItem
															xs={12}
															sm={6}
															md={4}
															className="affiliationsGridItem"
															style={{
																textAlign: 'center'
															}}
														>
															<Button
																variant="outlined"
																className="outlinedButton"
																style={{
																	color: '#55526f',
																	alignSelf: 'center',
																	margin: 'auto'
																}}
																className="passButton"
																onClick={() =>
																	this.handleClickOpenDialog(
																		t.id,
																		userTargetDetail
																	)
																}
															>
																{userTargetDetail && userTargetDetail.enabled
																	? 'Update Details'
																	: 'Activate'}
															</Button>
															<Dialog
																open={openD}
																onClose={() => this.handleCloseDialog(t.id)}
																aria-labelledby="form-dialog-title"
																className="centerFixedDialog"
															>
																<DialogTitle id="form-dialog-title">
																	{'Set User Details for ' + t.name}
																</DialogTitle>
																<DialogContent>
																	{t.name === 'Hollard0' ? (
																		<FormControl fullWidth>
																			<Field
																				component={FormInput}
																				isrequired={true}
																				checkValidation={
																					this.state.checkValidation
																				}
																				name={
																					'companyDetails.' + t.id + '.username'
																				}
																				label="Id Number"
																			/>
																		</FormControl>
																	) : (
																		<React.Fragment>
																			<FormControl fullWidth>
																				<Field
																					component={FormInput}
																					isrequired={true}
																					validate={[required]}
																					checkValidation={
																						this.state.checkValidation
																					}
																					name={
																						'companyDetails.' +
																						t.id +
																						'.username'
																					}
																					label="Username"
																				/>
																			</FormControl>
																			<FormControl fullWidth>
																				<Field
																					component={FormInputPassword}
																					showPassword={
																						dialog ? dialog.showPassword : false
																					}
																					handleClickShowPassword={() =>
																						this.toggleShowPassword(t.id)
																					}
																					isrequired={true}
																					checkValidation={
																						this.state.checkValidation
																					}
																					name={
																						'companyDetails.' +
																						t.id +
																						'.password'
																					}
																					label="Password"
																				/>
																			</FormControl>
																			<FormControl fullWidth>
																				<Field
																					component={FormInputPassword}
																					showPassword={
																						dialog
																							? dialog.showConfrimPassword
																							: false
																					}
																					handleClickShowPassword={() =>
																						this.toggleShowConfirmPassword(t.id)
																					}
																					isrequired={true}
																					checkValidation={
																						this.state.checkValidation
																					}
																					name={
																						'companyDetails.' +
																						t.id +
																						'.confirmpassword'
																					}
																					label="Confirm Password"
																				/>
																			</FormControl>
																		</React.Fragment>
																	)}
																</DialogContent>
																<DialogActions>
																	<Button
																		color="primary"
																		onClick={() => this.handleCloseDialog(t.id)}
																	>
																		Cancel
																	</Button>
																	<Button
																		color="primary"
																		onClick={() =>
																			this.updateTargetDetails(t, refetch)
																		}
																	>
																		Save
																	</Button>
																</DialogActions>
															</Dialog>
														</GridItem>
													</Grid>
												</Card>
											</GridItem>
										);
									})}






{EnabledTargets.map(t => {
										if(t.id != 1)
										return;
										let dialog = this.state.openDialogs.find(
											x => x.id === t.id
										);
										let openD = dialog ? dialog.open : false;
										let userTargetDetail = CompanyLoginD.find(
											c => c.targetId === t.id
										);

										return (
											<GridItem xs={12} sm={12} md={12} key={1}>
												<Card
													className="targetCard"
													style={{ paddingTop: '5px' }}
												>
													<Grid container>
														<GridItem
															xs={12}
															sm={12}
															md={4}
															className="affiliationsGridItem"
														>
															<img
																src={
																	'/assets/logo/' +
																	t.name.toLowerCase() +
																	'.png'
																}
																className="targetAffiliationLogo"
																style={{ alignSelf: 'center' }}
															/>
														</GridItem>
														<GridItem
															xs={12}
															sm={6}
															md={4}
															className="affiliationsGridItem"
														>
															{userTargetDetail &&
															userTargetDetail.enabled &&
															userTargetDetail.username ? (
																<React.Fragment>
																	<Typography variant="caption">
																		Username:{' '}
																	</Typography>
																	<Typography variant="subheading">
																		{userTargetDetail.username}
																	</Typography>
																</React.Fragment>
															) : null}
														</GridItem>
														<GridItem
															xs={12}
															sm={6}
															md={4}
															className="affiliationsGridItem"
															style={{
																textAlign: 'center'
															}}
														>
															<Button
																variant="outlined"
																className="outlinedButton"
																style={{
																	color: '#55526f',
																	alignSelf: 'center',
																	margin: 'auto'
																}}
																className="passButton"
																onClick={() =>
																	this.handleClickOpenDialog(
																		t.id,
																		userTargetDetail
																	)
																}
															>
																{userTargetDetail && userTargetDetail.enabled
																	? 'Update Details'
																	: 'Activate'}
															</Button>
															<Dialog
																open={openD}
																onClose={() => this.handleCloseDialog(t.id)}
																aria-labelledby="form-dialog-title"
																className="centerFixedDialog"
															>
																<DialogTitle id="form-dialog-title">
																	{'Set User Details for ' + t.name}
																</DialogTitle>
																<DialogContent>
																	{t.name === 'Hollard0' ? (
																		<FormControl fullWidth>
																			<Field
																				component={FormInput}
																				isrequired={true}
																				checkValidation={
																					this.state.checkValidation
																				}
																				name={
																					'companyDetails.' + t.id + '.username'
																				}
																				label="Id Number"
																			/>
																		</FormControl>
																	) : (
																		<React.Fragment>
																			<FormControl fullWidth>
																				<Field
																					component={FormInput}
																					isrequired={true}
																					validate={[required]}
																					checkValidation={
																						this.state.checkValidation
																					}
																					name={
																						'companyDetails.' +
																						t.id +
																						'.username'
																					}
																					label="Broker Code"
																				/>
																			</FormControl>
																			<FormControl fullWidth>
																				<Field
																					component={FormInput}
																					
																					
																					isrequired={true}
																					
																					name={
																						'companyDetails.' +
																						t.id +
																						'.password'
																					}
																					label="House Code"
																				/>
																			</FormControl>
																			
																		</React.Fragment>
																	)}
																</DialogContent>
																<DialogActions>
																	<Button
																		color="primary"
																		onClick={() => this.handleCloseDialog(t.id)}
																	>
																		Cancel
																	</Button>
																	<Button
																		color="primary"
																		onClick={() =>
																			this.updateTargetDetails(t, refetch)
																		}
																	>
																		Save
																	</Button>
																</DialogActions>
															</Dialog>
														</GridItem>
													</Grid>
												</Card>
											</GridItem>
										);
									})}













									

									<GridItem xs={12} sm={12} md={12}>
										<Card className="targetCard" style={{ paddingTop: '5px' }}>
											<Grid container>
												<GridItem
													xs={12}
													sm={12}
													md={4}
													className="affiliationsGridItem"
												>
													<img
														src={'/assets/logo/astute.jpg'}
														className="targetAffiliationLogo"
														style={{ alignSelf: 'center', width: '70px' }}
													/>
												</GridItem>
												<GridItem
													xs={12}
													sm={6}
													md={4}
													className="affiliationsGridItem"
												>
													{AstuteDetails &&
													AstuteDetails.enabled &&
													AstuteDetails.username ? (
														<React.Fragment>
															<Typography variant="caption">
																Username:{' '}
															</Typography>
															<Typography variant="subheading">
																{AstuteDetails.username}
															</Typography>
														</React.Fragment>
													) : null}
												</GridItem>
												<GridItem
													xs={12}
													sm={6}
													md={4}
													className="affiliationsGridItem"
													style={{
														textAlign: 'center'
													}}
												>
													<Button
														variant="outlined"
														className="outlinedButton"
														style={{
															color: '#55526f',
															alignSelf: 'center',
															margin: 'auto'
														}}
														className="passButton"
														onClick={() => this.handleOpenAstuteDialog()}
													>
														{AstuteDetails && AstuteDetails.enabled
															? 'Update Details'
															: 'Activate'}
													</Button>
													<Dialog
														open={this.state.astuteDialog}
														onClose={() => this.handleCloseAstuteDialog()}
														aria-labelledby="form-dialog-title"
														className="centerFixedDialog"
													>
														<DialogTitle id="form-dialog-title">
															{'Set Password for Astute'}
														</DialogTitle>
														<DialogContent>
															<FormControl fullWidth>
																<Field
																	component={FormInput}
																	isrequired={true}
																	validate={[required]}
																	checkValidation={this.props.checkValidation}
																	name={'astuteDetails.username'}
																	label="Username"
																/>
															</FormControl>
															<FormControl fullWidth>
																<Field
																	component={FormInputPassword}
																	showPassword={this.state.showPasswordAstute}
																	handleClickShowPassword={() =>
																		this.toggleShowPasswordAstute(
																			'showPasswordAstute'
																		)
																	}
																	name={'astuteDetails.password'}
																	label="Password"
																/>
															</FormControl>
															<FormControl fullWidth>
																<Field
																	component={FormInputPassword}
																	showPassword={
																		this.state.showConfrimPasswordAstute
																	}
																	handleClickShowPassword={() =>
																		this.toggleShowPasswordAstute(
																			'showConfrimPasswordAstute'
																		)
																	}
																	name={'astuteDetails.confirmpassword'}
																	label="Confirm Password"
																/>
															</FormControl>
															<FormControl fullWidth>
																<Field
																	component={FormInputPassword}
																	showPassword={this.state.showPinAstute}
																	handleClickShowPassword={() =>
																		this.toggleShowPasswordAstute(
																			'showPinAstute'
																		)
																	}
																	name={'astuteDetails.pin'}
																	label="Pin"
																/>
															</FormControl>
															<FormControl fullWidth>
																<Field
																	component={FormInputPassword}
																	showPassword={this.state.showConfirmPinAstute}
																	handleClickShowPassword={() =>
																		this.toggleShowPasswordAstute(
																			'showConfirmPinAstute'
																		)
																	}
																	name={'astuteDetails.confirmpin'}
																	label="Confirm Pin"
																/>
															</FormControl>
														</DialogContent>
														<DialogActions>
															<Button
																color="primary"
																onClick={() => this.handleCloseAstuteDialog()}
															>
																Cancel
															</Button>
															<Button
																color="primary"
																onClick={() =>
																	this.updateAstuteDetails(refetch)
																}
															>
																Save
															</Button>
														</DialogActions>
													</Dialog>
												</GridItem>
											</Grid>
										</Card>
									</GridItem>
								</Grid>
							</CardBody>
						</Card>
					</GridItem>
				</Grid>
			</div>
		);
	}
}

CompanyLoginDetails = graphql(companyLoginDetails, {
	options: () => ({ fetchPolicy: 'network-only' }),
	props: props => {
		if (props.data.error) {
		}
		return { ...props };
	}
})(CompanyLoginDetails);

CompanyLoginDetails = connect(state => ({
	userId: GetUserId(),
	token: GetUserToken()
}))(CompanyLoginDetails);

CompanyLoginDetails = compose(
	graphql(UpdateCompanyDetail, { name: 'UpdateCompanyDetail' }),
	graphql(UpdateAstuteDetails, { name: 'UpdateAstuteDetails' })
)(CompanyLoginDetails);

CompanyLoginDetails = reduxForm({
	form: form,
	destroyOnUnmount: true
})(CompanyLoginDetails);

export default withStyles(userProfileStyles)(CompanyLoginDetails);



// WEBPACK FOOTER //
// ./src/views/Profile/CompanyLoginDetails.jsx